import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import cx from 'classnames';

import s from './Hero.css';
import cs from '../../commonStyle.css';

import SearchBar from '../SearchBar/SearchBar';
import messages from '../../../locale/messages';

class Hero extends React.Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
  };

  render() {
    const { isAuthenticated } = this.props;

    return (
      <section className={cx(s.hero, isAuthenticated && s.heroWithSiteHeader)}>
        <div className={s.heroTop}>
          <div className={s.heroOverline}>
            <FormattedMessage {...messages.newLandingHeroOverline} />
          </div>
          <h1 className={s.heroTitle}>
            <FormattedMessage {...messages.batch2HomeH1} />
          </h1>
        </div>

        <div className={s.heroSearchWrapper}>
          <SearchBar />
        </div>
      </section>
    );
  }
}

const mapState = (state) => ({
  isAuthenticated: state.runtime.isAuthenticated,
});

export default compose(
  connect(mapState),
  withStyles(s, cs),
)(Hero);
